// extracted by mini-css-extract-plugin
export default {"bottomGrid":"ProjectContent_bottomGrid__34d6c","bottomGridItem":"ProjectContent_bottomGridItem__YZiOR"};